module.exports = __webpack_public_path__ + "static/media/art72.d941af99.jpg";